import {EventEmitter} from '@angular/core';
import {ClienteModel} from './cliente.model';
import {PedidosPreCargaModel} from './pedidos-pre-carga.model';
import {MotoristaModel} from '../../../models/motorista.model';
import {VeiculoModel} from '../../../models/veiculo.model';
import { AgendamentoPedidoModel } from './agendamento-pedido-model';
export class MarkerAGM {
  cor?: string;
  latitude: number;
  longitude: number;
  draggable: boolean;
  zIndex?: number;
  motorista?: MotoristaModel;
  veiculo?: VeiculoModel;
  icon: any;
  title: string;
  dadosRota?: string;
  label?: string;
  animation: string;
  sequencia?: any;
  cliente?: ClienteModel;
  labelIcon: string;
  openInfoWindow?: EventEmitter<any> = new EventEmitter();
  overlayPreCarga?: any;
  pedidoTransf?: boolean;
  idPreCarga?: string;
  pedidoBloqueadoPendente?: boolean;
  clientePossuiJanelaEntrega?: boolean;
  janelaEntregaHabilitada?: boolean;
  possuiCorConfigFiltro?: boolean;
  corConfigSalva?: string;
  pedidos: PedidosPreCargaModel[];
  zonaRisco: boolean;
  possuiObservacao?: boolean;
  isIdentificacaoPersonalizada?: boolean;
  isPontoPassagem?: boolean;
  isPontoParada?: boolean;
  reentrega?: boolean;
  possuiAgendamento?: boolean;
  pixelBounds?: any;
  idPraca?: string;
  agendamento?: AgendamentoPedidoModel;
  corRota?: string;
  praca?: string;
  descricaoRota?: string;
  valor?: number;
  idAreaAtendimento?: number;
  nomeAreaAtendimento?: string;
  possuiPedidoAvulso?: boolean;
  isVisivel = true;
  corRamoAtividade?: string;
  corCliente?: string;
  possuiPedidosEmAtraso?: boolean;
  idRota?: string;
  selecaoBloqueada?: boolean;

  get id() {
    if (!this.cliente.id) {
      return '';
    }
    const strEnderecoEntrega = this.cliente.idEndEntrega ? `_${this.cliente.idEndEntrega}` : '';
    return `${this.cliente.id}${strEnderecoEntrega}`;
  }

  get isMarkerPadrao() {
    return !this.possuiObservacao
      && !this.zonaRisco
      && !this.isIdentificacaoPersonalizada
      && !this.pedidoBloqueadoPendente
      && !this.clientePossuiJanelaEntrega
      && !this.idPreCarga
      && !this.reentrega;
  }


}
